





































































































import {
    defineComponent,
    computed,
    PropType,
    ref,
    watch
} from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm, sensor } from "@/store";
export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        EnrollDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/EnrollDialog.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: { type: Object as PropType<AttachedDeviceModel> },
    },
    setup(props, { emit }) {
        const hatchClosed = computed<boolean>(() => {
            return alarm.hatchClosed;
        });

        const responsive = computed<boolean>(() => {
            if (props.value.attachedDeviceId != null) {
                if (props.value.age <= 1) {
                    return true;
                } else {
                    return false;
                }
            }
        });

        const paired = computed<boolean>(() => {
            if (
                props.value &&
                props.value.attachedDeviceId &&
                props.value.attachedDeviceId !== ""
            ) {
                return true;
            } else {
                return false;
            }
        });

        const showEnroll = ref(false);

        const showSuccess = computed<boolean>(() => {
            return alarm.deviceAdded;
        });

        const showTimeout = computed<boolean>(() => {
            return alarm.deviceTimedOut;
        });

        const successOk = () => {
            alarm.SetNewDeviceAdded(false);
            sensor.GetData();
        };

        const timeoutOk = () => {
            alarm.SetNewDeviceTimedOut(false);
            sensor.GetData();
        };

        const imgSrc = computed(() => {
            return require(`@/assets/img/doorsensor.png`);
        });
        const onEnroll = () => {
            showEnroll.value = true;
        };
        const battery = computed(() => {
            return props.value ? !props.value.batteryLow : false;
        });
        watch(
            () => props.value,
            newValue => {
                if (newValue) {
                    console.log(newValue.batteryLow);
                }
            }
        );
        
        return {
            onEnroll,
            paired,
            showEnroll,
            imgSrc,
            responsive,
            battery,
            showSuccess,
            successOk,
            hatchClosed,
            showTimeout,
            timeoutOk,
        };
    }
});
